// extracted by mini-css-extract-plugin
export default {"drop_down":"styles_drop_down__Z4ffr","more_btn":"styles_more_btn__WKiYR"};